<template>
  <div class="page">
    <div class="rules">
      <img src="./images/rules-bg.jpg" class="img-fluid" />

      <div class="rules__info">
        <router-link :to=" { name: 'LiffProjAbbottAnd2026LotteryQ2EarnCount', query: $route.query }">
          <img src="./images/rules-btn.png" class="img-fluid" />
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {

}
</script>

<style lang="scss" scoped>
.rules {

  position: relative;


  &__info {
    position: absolute;
    bottom: 8%;
    left: 50%;
    transform: translateX(-50%);
    width: 60%;
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: center;
  }
}
</style>
